<template>
  <v-card v-if="data">
    <v-card-title>{{ title }}</v-card-title>
    <v-card-subtitle v-if="!creating">{{ data.description }}</v-card-subtitle>
    <v-form @submit.prevent="saveData">
      <v-card-text>
        <v-row v-if="!creating">
          <v-col>
            <v-text-field disabled hide-details="auto" label="ID" outlined filled dense v-model="data.id"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field hide-details="auto" label="Název" outlined filled dense v-model="data.name"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select hide-details="auto" label="Práva"
                      :items="permissions"
                      item-text="name"
                      item-value="code"
                      multiple
                      outlined filled dense v-model="data.permissions"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea hide-details="auto" label="Název" outlined filled dense v-model="data.description" rows="3"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn outlined small color="primary" to="/app/roles" exact class="mx-1">Zrušit</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" class="mx-1" type="submit">Uložit</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>

export default {
  name: "RoleCard",
  props: {
    id: {
      required: false,
      default: () => null
    },
    creating: {
      type: Boolean
    }
  },
  data() {
    return {
      data: null,
      saveModel: {
        description: null,
        name: null,
        permissions: []
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.creating) {
        this.data = this.saveModel
        return
      }
      this.axios.get('/api/admin/role/' + this.id)
          .then(({data}) => {
            this.data = data
          }).catch(() => this.$router.go(-1))
    },
    saveData() {
      const saveData = Object.assign({}, this.saveModel)
      if (this.creating) {
        this.axios.post('/api/admin/role', saveData)
            .then(({data}) => {
              this.data = data.data
              this.$router.push('/app/roles/' + data.data.id)
              this.$store.dispatch('fetchRoles')
            })
        return
      }
      this.axios.put('/api/admin/role/' + this.id, saveData)
          .then(({data}) => {
            this.data = data.data
            this.$store.dispatch('fetchRoles')
          })
    }
  },
  computed: {
    title() {
      if (this.creating)
        return 'Vytvořit roli'
      return this.data.name
    },
    permissions() {
      return this.$store.state.types.permission
    }
  },
  watch: {
    data: {
      deep: true,
      handler: function (value) {
        if (!value) return
        Object.keys(value).forEach(key => {
          this.saveModel[key] = value[key]
        })
      }
    }
  }
}
</script>

<style scoped>

</style>